import { LocalizedValueModel } from '.';

export enum EntityViewTypeEnum {
  TableView = 0,
  CardView = 1,
  CalenderView = 2,
  KanbanBoard = 3,
  Timeline = 4,
  TreeView = 5,
  MiniCard = 6,
}

export interface EntityViewAction {
  id: string;
  name: LocalizedValueModel | string;
  type: EntityViewTypeEnum;
  icon: string;
  isSelected?: boolean;
}
